import React from 'react';
import TextInput from '../../form/TextInput';
import Select from '../../form/Select';
import createForm from "./Form";
import DateTimeInput from "../../form/DateTimeInput";
import Button from "../../form/Button";
import Icon from "../../form/Icon";
import classNames from "classnames";
import moment from "moment";

class TimeConfigForm extends React.Component {

    render() {
        const diff = moment(this.props.values.to, 'HH:mm:00').diff(moment(this.props.values.from, 'HH:mm:00'));
        const realDuration = moment().startOf('day').add(diff, 'milliseconds');
        const duration = moment(this.props.values.duration, 'HH:mm:00').diff(realDuration);
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-md-2">
                        <TextInput
                            name={this.props.componentConfig.idfield}
                            value={this.props.values[this.props.componentConfig.idfield]}
                            label="Kód"
                            role="idfield"
                            {...this.props.getFieldProps(this.props.componentConfig.idfield)}
                        />
                    </div>
                    <div className="col-md-5">
                        <Select
                            component="Program"
                            name="program"
                            value={this.props.values.program}
                            label="Program"
                            labelKey="name"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("program")}
                        />
                    </div>
                    <div className="col-md-5">
                        <Select
                            component="location"
                            name="location"
                            value={this.props.values.location}
                            label="Helyszín"
                            labelKey="name"
                            isClearable={true}
                            filter={[{
                                field: "roles.optionid",
                                value: "2"
                            }]}
                            storeType="local"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("location")}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-2">
                        <Select
                            name="from_weekday"
                            storeType="local"
                            optionname="weekday"
                            objectValue={false}
                            value={this.props.values.from_weekday}
                            label="Hét napjától"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("from_weekday")}
                        />
                    </div>
                    <div className="col-md-2">
                        <Select
                            name="to_weekday"
                            storeType="local"
                            optionname="weekday"
                            objectValue={false}
                            value={this.props.values.to_weekday}
                            label="Hét napjáig"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("to_weekday")}
                        />
                    </div>
                    <div className="col-md-2">
                        <DateTimeInput
                            {...this.props.getFieldProps("from")}
                            name="from"
                            value={this.props.values.from}
                            label="Mettől"
                            timeOnly={true}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col-md-2">
                        <DateTimeInput
                            {...this.props.getFieldProps("to")}
                            name="to"
                            value={this.props.values.to}
                            label="Meddig"
                            timeOnly={true}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col-md-4">
                        <label className="control-label">Időtartam</label>
                        <div className="input-group">
                            <div className="input-group-btn">
                                <Button
                                    className={classNames("btn", {"btn-default": this.props.values.duration !== "01:00:00", "btn-primary": this.props.values.duration === "01:00:00"})}
                                    tooltip="Egy órás"
                                    onClick={() => {
                                        this.props.setFieldValue("duration", "01:00:00");
                                    }}>
                                    1
                                </Button>
                            </div>
                            <div className="input-group-btn">
                                <Button
                                    className={classNames("btn", {"btn-default": this.props.values.duration !== "02:00:00", "btn-primary": this.props.values.duration === "02:00:00"})}
                                    tooltip="Két órás"
                                    onClick={() => {
                                        this.props.setFieldValue("duration", "02:00:00");
                                    }}>
                                    2
                                </Button>
                            </div>
                            <DateTimeInput
                                {...this.props.getFieldProps("duration")}
                                name="duration"
                                value={this.props.values.duration}
                                label={false}
                                timeOnly={true}
                                saveChanges={this.props.setFieldValue}
                            />
                            <div className="input-group-btn">
                                <Button
                                    className={classNames("btn", {"btn-default": duration, "btn-primary": !duration})}
                                    tooltip="Teljes időtartam"
                                    onClick={() => {
                                        this.props.setFieldValue("duration", realDuration.format('HH:mm:00'));
                                    }}
                                >
                                    <Icon lib="fas" name="clock"/>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-3">
                        <Select
                            optionname="repeattype"
                            storeType="local"
                            name="repeat_type"
                            value={this.props.values.repeat_type}
                            label="Ismétlés típusa"
                            objectValue={false}
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("repeat_type")}
                        />
                    </div>
                    <div className="col-md-3">
                        <TextInput
                            name="repeat_interval"
                            type="number"
                            value={this.props.values.repeat_interval}
                            label="Ismétlés intervallum"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("repeat_interval")}
                        />
                    </div>
                    <div className="col-md-3">
                        <DateTimeInput
                            {...this.props.getFieldProps("repeatstart")}
                            name="repeatstart"
                            value={this.props.values.repeatstart}
                            label="Ismétlés kezdete"
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col-md-3">
                        <DateTimeInput
                            {...this.props.getFieldProps("repeatend")}
                            name="repeatend"
                            value={this.props.values.repeatend}
                            label="Ismétlés vége"
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(TimeConfigForm);
